module.exports = __webpack_public_path__ + "media/game-video.3ffba96d.mp4";